import {TYPES} from '../Actions/userManagementAction';
import * as moment from 'moment';

const userManagementReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.FETCH_ALL_COMPANIES_SUCCESS:
            return {
                ...state,
                allCompanies: action.allCompanies
            };
        case TYPES.FETCH_ALL_USER_INSURERS_SUCCESS:
            return {
                ...state,
                allUserInsurers: action.allUserInsurers
            };
        case TYPES.FETCH_ALL_USER_SUBAGENTS_SUCCESS:
            return {
                ...state,
                allUserSubagents: action.allUserSubagents
            };
        case TYPES.FETCH_REG_INSURERS_SUCCESS:
            return {
                ...state,
                registeredInsurers: action.registeredInsurers
            };
        case TYPES.FETCH_REG_SUBAGENTS_SUCCESS:
            return {
                ...state,
                registeredSubagents: action.registeredSubagents
            };
        case TYPES.FETCH_INSURER_HISTORY_SUCCESS:
            return {
                ...state,
                insurerHistory: action.insurerHistory
            };
        case TYPES.FETCH_SUBAGENT_HISTORY_SUCCESS:
            return {
                ...state,
                subagentHistory: action.subagentHistory
            };
        case TYPES.MANAGE_USER_SUCCESS:
            return {
                ...state,
                manageStatus: action.manageStatus
            };
        case TYPES.FETCH_ALL_NORMAL_USERS_SUCCESS:
            return {
                ...state,
                allNormalUsers: action.allNormalUsers
            };
        case TYPES.FETCH_ALL_API_USERS_SUCCESS:
            return {
                ...state,
                allApiUsers: action.allApiUsers
            };
        case TYPES.FETCH_COMPANY_COUNT_SUCCESS:
            return {
                ...state,
                companyCount: {
                    value: action.companyCount,
                    updatedAt: moment()
                }
            };
        case TYPES.FETCH_NORMAL_USERS_COUNT_SUCCESS:
            return {
                ...state,
                normalUserCount: {
                    value: action.normalUserCount,
                    updatedAt: moment()
                }
            };
        case TYPES.FETCH_API_USERS_COUNT_SUCCESS:
            return {
                ...state,
                apiUserCount: {
                    value: action.apiUserCount,
                    updatedAt: moment()
                }
            };
        default:
            return state;
    }
};

export default userManagementReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/userManagementReducer.ts